module.exports = __webpack_public_path__ + "static/Principal-Black-8987cd27e1daddb5ed0c4618ca9dec13.woff";